import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { GUIDES } from '../guidesData';

const Guides = () => (
  <div className="min-h-screen bg-white" data-testid="guides-index">
    <SEO title="Freeze Dryer Troubleshooting Guides" description="Practical guides on common freeze dryer problems — won't pull vacuum, not freezing, error codes, wet product — and how they're fixed." keywords="freeze dryer troubleshooting, freeze dryer problems, freeze dryer guides" />
    <Navbar />
    <section className="bg-[#003456] pt-16 pb-16 section-padding">
      <div className="max-w-7xl mx-auto">
        <span className="inline-flex items-center gap-2 text-[#CE8946] font-semibold text-xs uppercase tracking-[0.2em]"><BookOpen className="h-4 w-4" /> Guides &amp; troubleshooting</span>
        <h1 className="text-4xl sm:text-5xl font-bold text-white mt-4 leading-tight max-w-3xl">Freeze dryer troubleshooting guides</h1>
        <p className="text-white/70 mt-5 max-w-2xl leading-relaxed">Straight answers to the problems we see most — what causes them and how a professional rebuild puts your machine right.</p>
      </div>
    </section>
    <section className="py-20 section-padding bg-white">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {GUIDES.map((g) => (
          <Link key={g.slug} to={`/guides/${g.slug}`} className="group bg-[#F1F5F9] rounded-2xl p-7 border border-slate-200 hover:border-[#CE8946] transition-colors flex flex-col" data-testid={`guide-card-${g.slug}`}>
            <h2 className="text-lg font-bold text-[#003456] group-hover:text-[#B87333] transition-colors">{g.title}</h2>
            <p className="text-slate-600 text-sm mt-2 leading-relaxed flex-1">{g.excerpt}</p>
            <span className="inline-flex items-center gap-1 text-[#CE8946] font-semibold text-sm mt-4">Read guide <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" /></span>
          </Link>
        ))}
      </div>
    </section>
    <Footer />
  </div>
);

export default Guides;
